<template>
  <div>
    <v-row no-gutters justify="start">
      <div class="side-content-small ml-6">
        <v-row no-gutters align="center" class="content-header">
          <v-icon class="mr-3">settings</v-icon>
          <div class="font-weight-bold">
            Indeego
          </div>
        </v-row>
        <div class="left-indeego-settings-nav">
          <ul>
            <li
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ active: tab.isActive }"
              @click="goTo(tab.path)"
            >
              <v-icon class="float-right">keyboard_arrow_right</v-icon>
              <div>{{ tab.text }}</div>
            </li>
          </ul>
        </div>
      </div>
      <v-col align="center" class="pa-0 mx-6">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`ui/indeegoSettings`, {
      storeTabs: `tabs`,
    }),
    tabs() {
      return this.storeTabs.map(tab => ({
        ...tab,
        isActive: this.$route.path === tab.path,
      }));
    },
  },
  methods: {
    goTo(path) {
      if (path !== this.$route.path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
